import React, { useContext, Fragment } from 'react';
import PropTypes from 'prop-types';
import Link from '../Link';
import { StyledDivColumn, StyledHeader, footerLink, footerHeader } from './styles';
import { AnalyticsContext } from '../../context/analyticsContext';

const DesktopFooterMenu = props => {
  const { columns } = props;
  const { analyticsClient } = useContext(AnalyticsContext);
  if (!columns) return null;

  return (
    <>
      {columns.map(({ header, children }, columnIndex) => {
        const headerKey = `footer-menu-col-${columnIndex}-header`;
        return (
          <StyledDivColumn
            className="footer-menu-column"
            data-testid={`footer-menu-column-${columnIndex}`}
            key={columnIndex}
          >
            {header.label &&
              (header.url ? (
                <Link
                  className={footerHeader}
                  dataTestId={headerKey}
                  href={header.url}
                  onClick={() => {
                    analyticsClient?.clickNavFooter({
                      path: header.path.join(':'),
                      hashKey: header.hashKey,
                    });
                  }}
                  text={header.label}
                />
              ) : (
                <StyledHeader data-testid={headerKey}>{header.label}</StyledHeader>
              ))}
            {children.map((link, linkIndex) => {
              const destination = link.url;
              if (!destination) return null;
              const linkKey = `footer-menu-col-${columnIndex}-child-${linkIndex}`;
              return (
                <Link
                  className={footerLink}
                  dataTestId={linkKey}
                  href={destination}
                  key={linkKey}
                  onClick={() => {
                    analyticsClient?.clickNavFooter({
                      path: link.path.join(':'),
                      hashKey: link.hashKey,
                    });
                  }}
                  target={link.target}
                  text={link.label}
                />
              );
            })}
          </StyledDivColumn>
        );
      })}
    </>
  );
};

DesktopFooterMenu.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.object,
      children: PropTypes.arrayOf(PropTypes.object),
    }),
  ),
};

export default DesktopFooterMenu;
